import './TicketPage.less';

import clsx from 'clsx';
import React from 'react';

import { FilteringSlider } from '@/nikeone/components/FilterSlider';

export default function TicketPage({ className, active, filters, autoHeight, children }) {
    return <MobilePageView className={className} filters={filters} autoHeight={autoHeight} children={children} />;
}

function MobilePageView({ className, filters, autoHeight, children }) {
    return (
        <div className={clsx('ticket-page', className, { 'ticket-page-full-height': !autoHeight })}>
            {filters && <FilteringSlider>{filters}</FilteringSlider>}
            {children}
        </div>
    );
}
